import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SaveCorrectionAndRematchMutationVariables = Types.Exact<{
  publicId: Types.Scalars["String"];
  id: Types.Scalars["ID"];
  data: Types.EmailDocumentCorrectionDataInput;
}>;

export type SaveCorrectionAndRematchMutation = {
  __typename?: "Mutation";
  saveCorrectionAndRematch: {
    __typename?: "RematchResult";
    outcome: Types.MatchOutcome;
    matchedTransactionId?: string | null;
    emailDocument: {
      __typename?: "EmailDocument";
      id: string;
      name?: string | null;
      amount?: number | null;
      currency?: string | null;
      documentNumber?: string | null;
      date?: string | null;
      matchStatus?: Types.DocumentMatchStatus | null;
      transactionId?: string | null;
      correctionData?: {
        __typename?: "EmailDocumentCorrectionData";
        name?: string | null;
        amount?: number | null;
        currency?: string | null;
        documentNumber?: string | null;
        date?: string | null;
        description?: string | null;
      } | null;
    };
  };
};

export const SaveCorrectionAndRematchDocument = gql`
  mutation saveCorrectionAndRematch(
    $publicId: String!
    $id: ID!
    $data: EmailDocumentCorrectionDataInput!
  ) {
    saveCorrectionAndRematch(publicId: $publicId, id: $id, data: $data) {
      outcome
      matchedTransactionId
      emailDocument {
        id
        name
        amount
        currency
        documentNumber
        date
        matchStatus
        transactionId
        correctionData {
          name
          amount
          currency
          documentNumber
          date
          description
        }
      }
    }
  }
`;
export type SaveCorrectionAndRematchMutationFn = Apollo.MutationFunction<
  SaveCorrectionAndRematchMutation,
  SaveCorrectionAndRematchMutationVariables
>;

/**
 * __useSaveCorrectionAndRematchMutation__
 *
 * To run a mutation, you first call `useSaveCorrectionAndRematchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCorrectionAndRematchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCorrectionAndRematchMutation, { data, loading, error }] = useSaveCorrectionAndRematchMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveCorrectionAndRematchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveCorrectionAndRematchMutation,
    SaveCorrectionAndRematchMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveCorrectionAndRematchMutation,
    SaveCorrectionAndRematchMutationVariables
  >(SaveCorrectionAndRematchDocument, options);
}
export type SaveCorrectionAndRematchMutationHookResult = ReturnType<
  typeof useSaveCorrectionAndRematchMutation
>;
export type SaveCorrectionAndRematchMutationResult =
  Apollo.MutationResult<SaveCorrectionAndRematchMutation>;
export type SaveCorrectionAndRematchMutationOptions =
  Apollo.BaseMutationOptions<
    SaveCorrectionAndRematchMutation,
    SaveCorrectionAndRematchMutationVariables
  >;
